import { render, staticRenderFns } from "./ImeiItem.vue?vue&type=template&id=1f5a6460&scoped=true"
import script from "./ImeiItem.vue?vue&type=script&lang=js"
export * from "./ImeiItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a6460",
  null
  
)

export default component.exports